import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper/bundle';
import { isMobile } from "./exportFunc";
export default ()=>{
    gsap.registerPlugin(ScrollTrigger);
    let OFFSET;
    const homeMap = document.querySelector('[home-map]');
    isMobile()?OFFSET = "top bottom-=150px":OFFSET = "top bottom-=250px";
    homeMap?mapHandle():false;

    function mapHandle(){
        const timeLine = gsap.timeline({
            scrollTrigger: {
                trigger: '.home-map__box',
                start: OFFSET,
            },
        })
        timeLine.to('[map-element]',  {
            opacity: 1,
            ease: "Power1.easeIn",
            duration:1,
            stagger: 0.3
        });
    }

    function initMap () {
        const buttons = [...document.querySelectorAll('.spot-map__btn')];

        const removeActiveClasses = () => {
            buttons.forEach(el => el.classList.remove('spot-map__btn--active'))
        }

        const addActiveClass = (dataSlide) => {
            const slideNumber = document.querySelector(`[data-slide-target='${dataSlide}']`)
            slideNumber.classList.add('spot-map__btn--active')
        }

        const spotMapSlider = new Swiper('.spot-map__slider-container', {
            slidesPerView: 1,

            navigation: {
            nextEl: '.spot-map__slider-btn-next',
            prevEl: '.spot-map__slider-btn-prev',
            },

            on: {
            slideChange: function () {
                const currentSlide = spotMapSlider.slides[spotMapSlider.realIndex];
                const dataSlide = currentSlide.dataset.slide;

                removeActiveClasses();

                addActiveClass(dataSlide);
            },
            },
        });

        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
            const slideNumber = btn.dataset.slideTarget

            spotMapSlider.slideTo(slideNumber)
            })
        })

        const findActive = () => {
            const activeEl = document.querySelector('.spot-map__btn--active');
            if(!activeEl) return
            const activeIndex = activeEl.dataset.slideTarget;

            spotMapSlider.slideTo(activeIndex)
        }

        findActive();
    }

    initMap()
}